// A synthetic anchor rather than `window.open`, which popup blockers stop once an await has left the user's click
export const openInNewTab = (url: string): void => {
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.target = '_blank';
  anchor.rel = 'noreferrer';
  anchor.click();
};

// Fully client-side blob download via a transient anchor (the legacy app
// round-tripped exports through a server endpoint).
export const downloadBlob = (content: BlobPart, fileName: string, mimeType: string): void => {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
};
